import React from 'react';
import BaseModule from '../../logic/module/BaseModule';
import { AppRoute } from '../../components';

export const NAME = 'rewards';

export default class RewardsModule extends BaseModule {
  getName() {
    return NAME;
  }

  getPermission() {
    return 'rewards.*';
  }

  getPolicy() {
    return 'Admin:Reward:View:*';
  }

  getNavigation() {
    return [
      {
        label: 'Rewards',
        icon: 'trophy',
        path: null,
        permission: 'rewards.*',
        policy: 'Admin:Reward:View:*',
        children: [
          {
            label: 'Retailers',
            icon: 'registered',
            path: '/rewards/retailers',
            permission: 'rewards.retailers.*',
            policy: 'Admin:Reward:View:*',
          },
          {
            label: 'Promotions',
            icon: 'product-hunt',
            path: '/rewards/promotions',
            permission: 'rewards.promotions.*',
            policy: 'Admin:Reward:View:*',
          }
        ]
      }
    ];
  }

  getRoutes(currentUrl = '') {
    return [
      <AppRoute
        path={`${currentUrl}rewards`}
        load={() => import('./RewardPage')}
      />
    ];
  }
}
